import { render, staticRenderFns } from "./SuggestedPolicyModal.vue?vue&type=template&id=40812af8&"
import script from "./SuggestedPolicyModal.vue?vue&type=script&lang=js&"
export * from "./SuggestedPolicyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports